import type { TFunction } from 'i18next';

enum TaskSortBy {
  CREATED_DATE = 'created_date',
  POINTS = 'points',
  TYPE = 'type',
}

/**
 * Build the task-list sort-by options against the caller's translation
 * function so org-level text_config overrides apply.
 *
 * @param {TFunction} t - Translation function from `useTranslation()`
 * @returns Array of `{ label, value }` options for the sort-by select
 */
const getTaskSortByOptions = (t: TFunction) => [
  // Single key — concatenating `${t('common.created')} Date` mixes a
  // translated token with a hardcoded English suffix and breaks any locale
  // whose word order or grammar differs.
  { label: t('common.created_date'), value: TaskSortBy.CREATED_DATE },
  { label: t('common.estimation'), value: TaskSortBy.POINTS },
  { label: t('common.type'), value: TaskSortBy.TYPE },
];

export { getTaskSortByOptions, TaskSortBy };
